import Taro from './taro/index'

export * from './api/index'

export default Taro
export * from './taro/index'
